<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="toc"><a class="xref" href="#/chitunbridge0007#intro"><span class="sm">INTRODUCTION</span>  An Anxious Age</a></p>
<p class="toc"><a class="xref" href="#/chitunbridge0008#ch01"><span class="sm">ONE</span>  Transatlantic Arrivals</a></p>
<p class="toc"><a class="xref" href="#/chitunbridge0009#ch02"><span class="sm">TWO</span>  Languages of Listening</a></p>
<p class="toc"><a class="xref" href="#/chitunbridge0010#ch03"><span class="sm">THREE</span>  Lieder Society</a></p>
<p class="toc"><a class="xref" href="#/chitunbridge0011#ch04"><span class="sm">FOUR</span>  Saving Music</a></p>
<p class="tocbmf"><a class="xref" href="#/chitunbridge0012#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chitunbridge0013#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chitunbridge0015#sel_bib">Selected Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chitunbridge0016#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-tunbridge-0006.vue?bd59fede